<template>
  <div class="keywords-list">
    <HollowDotsSpinner
      v-if="isLoading"
      class="keywords-list__loading"
      :animation-duration="1000"
      :dot-size="15"
      :dots-num="3"
      :color="'#95a5a6'"
    />
    <WithPaginationAndFilters v-else :data="bids" :is-raised="false">
      <template slot-scope="{ sortChange, filterChange, data }">
        <ElTable
          ref="bidsTable"
          class="keywords-list__table"
          row-class-name="keywords-list__row"
          cell-class-name="keywords-list__column"
          :data="data"
          row-key="id"
          border
          show-summary
          :summary-method="getSummaries"
          @sort-change="sortChange"
          @filter-change="filterChange"
          @cell-mouse-enter="changeCurrentHoveredRow"
          @selection-change="emitSelectionChange"
        >
          <ElTableColumn
            class-name="keywords-list__column--no-border"
            align="center"
            type="selection"
            width="55"
            fixed
            reserve-selection
          />

          <Component
            :is="column.component"
            v-for="(column, index) in columns"
            :key="column.property + index"
            :label="column.label"
            :prop="column.property"
            :current-hovered-row-id="currentHoveredRowId"
            :fixed="column.fixed"
            :class-name="getFixedClassNameIfFixed(column.fixed)"
            :read-only="column.readOnly"
            :width="column.width"
          />
        </ElTable>
      </template>
    </WithPaginationAndFilters>
  </div>
</template>
<script>
import WithPaginationAndFilters from '@@/common/paginations/WithPaginationAndFilters';
import ColumnWithHelp from '@@/advertisement/common/ColumnWithHelp';

import HollowDotsSpinner from '@@/common/HollowDotsSpinner';

import calculateSummary from '@/utils/calculateSummary';

import { format as priceFormat } from '@/utils/number';

export default {
  name: 'BidsList',
  components: {
    WithPaginationAndFilters,
    ColumnWithHelp,
    HollowDotsSpinner,
  },
  props: {
    bids: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      required: true,
    },
    resetSelectionController: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentHoveredRowId: -1,
    };
  },
  computed: {
    columnsSummaryBehaviour() {
      const columnsBehaviour = {};

      this.columns.forEach(col => {
        if (col.summaryBehaviour) {
          columnsBehaviour[col.property] = col.summaryBehaviour;
        }
      });

      return columnsBehaviour;
    },
  },
  created() {
    this.resetSelectionController.onResetSelection(this.clearBidsSelection);
  },
  beforeDestroy() {
    this.resetSelectionController.removeOnResetSelection(
      this.clearBidsSelection,
    );
  },
  methods: {
    priceFormat,
    clearBidsSelection() {
      if (this.$refs.bidsTable && this.$refs.bidsTable.clearSelection) {
        this.$refs.bidsTable.clearSelection();
      }
    },
    getFixedClassNameIfFixed(isFixed) {
      return isFixed ? 'keywords-list__column--no-border' : '';
    },
    getSummaries(param) {
      const { columns, data } = param;

      return calculateSummary({
        columns,
        data,
        columnsBehaviour: this.columnsSummaryBehaviour,
      });
    },
    emitSelectionChange(selection) {
      this.$emit('selection-change', selection);
    },
    changeCurrentHoveredRow({ id }) {
      this.currentHoveredRowId = id;
    },
  },
};
</script>
<style lang="scss">
.keywords-list {
  $base: keywords-list;

  display: flex;
  flex-direction: column;

  &__loading {
    align-self: center;
    display: flex;
    align-items: center;
    height: 150px;
  }

  &__row {
    &.expanded + tr .el-table__expanded-cell {
      border-right: $lb-table-border;
      border-left: $lb-table-border;
      background-color: lighten($lb-light-gray, 6);

      &:hover {
        background-color: lighten($lb-light-gray, 6) !important;
      }
    }
  }

  .el-table__fixed-footer-wrapper {
    @include rtl() {
      direction: ltr;
    }

    .#{$base}__column--no-border {
      border-right: 0;
    }
  }

  &__column {
    border-color: $--border-color-lighter;

    &--no-border {
      @include rtl() {
        &:not(:first-child) {
          border-right: 0;
        }

        border-left-width: 0;
        border-right-width: 1px;
      }
      border-left: 0;
    }
    border-right-width: 0;
    border-left: 1px solid $--border-color-lighter;
  }
}
</style>
